import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { InvestigationFormRepository } from '../../../infrastructure/repositories/investigation-form.repository';
import { InvestigationFormState } from '../../states/investigation-form.state';
import { ReorderFieldsCommand } from './reorder-fields.command';

@Injectable({ providedIn: 'root' })
export class ReorderFieldsUseCase {
  private readonly _repository = inject(InvestigationFormRepository);
  private readonly _state = inject(InvestigationFormState);

  public execute(command: ReorderFieldsCommand): Observable<void> {
    this._state.setLoadingInvestigationForm(true);
    this._state.clearErrorInvestigationForms();

    return this._repository.reorderFields(command.versionId, command.fields).pipe(
      catchError((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          'Failed to reorder fields';
        this._state.setErrorInvestigationForms(errorMessage);
        return throwError(() => error);
      }),
      finalize(() => this._state.setLoadingInvestigationForm(false))
    );
  }
}
